<!--
 * @Description: 申请退款
 * @Author:  wang.y
-->
<template>
  <Modal v-model="modelIndex" width="530" class="login-model" @on-cancel="close" @on-visible-change="clearForms" :footer-hide="true">
    <div class="container-wrapper">
      <div class="model-bg-wrapper">
        <img :src="static_img_url + 'pic/modal-bg-top.png?v=' + $store.state.imgVersion" />
        <img :src="static_img_url + 'pic/modal-bg-btm.png?v=' + $store.state.imgVersion" />
      </div>
      <div class="container-content">
        <div class="container-top">
          <div class="container-title reset-form-title">{{'申请退款' | dealLanguage('Request a Refund')}}</div>
          <Form ref="apply-invoice" :label-width="74" label-position="left" :model="currentForm" :rules="ruleValidate">
            <FormItem :label="'退款金额' | dealLanguage('Amount')" class="lh30">
              <span>¥{{orderItem.paymentAmount}}</span>
            </FormItem>
            <FormItem prop="reason" :label="'退款原因' | dealLanguage('Reason')">
              <Select v-model="currentForm.reason" :placeholder="'请选择退款原因' | dealLanguage('Please select a refund reason')">
                <Option v-for="item in reason_list" :value="item" :key="item">{{ item }}</Option>
              </Select>
            </FormItem>
            <FormItem prop="remark" :label="'退款备注' | dealLanguage('Notes')">
              <Input type="textarea" v-model="currentForm.remark" :placeholder="'请填写退款备注' | dealLanguage('Please fill in the refund note')"></Input>
            </FormItem>
          </Form>
        </div>
        <div class="container-bottom ">
          <div class="tip tip2">
            {{'退款申请通过后，将退款金额以原渠道退回。' | dealLanguage('After the refund application is approved, the refund amount will be returned through the original channel.')}}
          </div>
          <div class="btns-wrapper">
            <Button class="close-btn" type="primary" @click="close">{{'取消' | dealLanguage('Cancel')}}</Button>
            <Button class="submit-btn" type="primary" @click="applyInvoice">{{'提交' | dealLanguage('Submit')}}</Button>
          </div>
        </div>
      </div>
    </div>
  </Modal>
</template>

<script>
import {
  ordercancel,
} from '@/service/vbef'
import filter from 'js/filter'
import { mapState } from 'vuex'
export default {
  data() {
    return {
      filter,
      orderItem: {},
      orderIndex: 0,
      modelIndex: false,
      buttonLoading: false,
      currentForm: {
        reason: '',
        remark: '',
      },
      ruleValidate: {
        reason: [{ required: true, message: filter.dealLanguage('请选择退款原因', 'Please select a refund reason'), trigger: 'change' }],
      },
      reason_list: [
        filter.dealLanguage('我不想要了', "I don't want it anymore"), 
        filter.dealLanguage('重复购买', 'Repeat purchase'), 
        filter.dealLanguage('行程安排有冲突', 'There is a conflict in the schedule'), 
        filter.dealLanguage('其他', 'Other')
      ],
    }
  },
  computed: {
    ...mapState({
      static_img_url: (state) => state.static_img_url,
      index2_path: (state) => state.index2_path,
      index_path: (state) => state.index_path,
      user_key: (state) => state.user_key,
      language: (state) => state.language,
    }),
  },
  methods: {
    close() {
      this.modelIndex = false
    },
    clearForms(value) {
      if (value) return
      this.$refs['apply-invoice'].resetFields()
    },
    applyInvoice() {
      this.$refs['apply-invoice'].validate(async (valid) => {
        if (valid) {
          this.buttonLoading = true
          this.currentForm.orderId = this.orderItem.id
          this.currentForm.userKey = this.user_key
          let res = await ordercancel(this.currentForm)
          this.buttonLoading = false
          if (res.code == 0) {
            this.$Message.success(this.language == 'zh' ? '申请成功！' : 'Application successful!')
            this.$emit('success', this.orderIndex)
            this.modelIndex = false
          } else {
            this.$Message.error(filter.dealLanguage(res.msg, res.enMsg || res.msg))
          }
        }
      })
    },
  },
  created() {},
  mounted() {},
}
</script>

<style lang="stylus" scoped>
@import '~styles/login.styl'
@import '~styles/modal-form-pc.styl'
</style>
